import React from "react";
import { useShopModel } from "../shopModel";
import { SearchTypeEnum, ISearchValue } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import useMdmModel from "../../../../model/mdmModel";

export function PageHeader() {
    const { mdmCatalog, mdmBranch, mdmOrgan,entity } = useMdmModel();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useShopModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "分支编码",
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "从属机构",
            fieldName: "orgCode",
            treeData: mdmOrgan
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联实体",
            fieldName: "bentityCode",
            options: entity
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "门店名称",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [{ label: "启用", value: "0" }, { label: "禁用", value: "1" }]
        }
    ]

    return (
        <YhPageHeader
            title="门店管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}